"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToEnv = exports.loadStateFromEnv = void 0;
// Needs to validate the parameters outside of the function
function loadStateFromEnv(outputEnvVarNames) {
    const result = {};
    for (const [propertyName, envVarName] of outputEnvVarNames) {
        result[propertyName] = process.env[envVarName];
    }
    return result;
}
exports.loadStateFromEnv = loadStateFromEnv;
// Needs to validate the parameters outside of the function
function mapStateToEnv(state, outputEnvVarNames, excludedProperties) {
    const result = new Map();
    for (const [outputName, envVarName] of outputEnvVarNames) {
        if (!(excludedProperties === null || excludedProperties === void 0 ? void 0 : excludedProperties.includes(outputName))) {
            result.set(envVarName, state[outputName]);
        }
    }
    return result;
}
exports.mapStateToEnv = mapStateToEnv;
//# sourceMappingURL=utils.js.map